import { PLAN_REF_ID_MAPPING, PLAN_REF_ID_MAPPING_V1 } from "@/data/plans";
import { TProductRefId, TProductRefIdV1 } from "@/types/plan";

export const PLAN_RULE_BOOK_FOR_V1: Record<TProductRefIdV1, TProductRefId[]> = {
  [PLAN_REF_ID_MAPPING_V1.select]: [PLAN_REF_ID_MAPPING.culling],
  [PLAN_REF_ID_MAPPING_V1.edit]: [PLAN_REF_ID_MAPPING.editing],
  [PLAN_REF_ID_MAPPING_V1.essential]: [
    PLAN_REF_ID_MAPPING.culling,
    PLAN_REF_ID_MAPPING.editing,
  ],
  [PLAN_REF_ID_MAPPING_V1.pro]: [
    PLAN_REF_ID_MAPPING.culling,
    PLAN_REF_ID_MAPPING.editing,
  ],
  [PLAN_REF_ID_MAPPING_V1.pro_trial]: [
    PLAN_REF_ID_MAPPING.culling,
    PLAN_REF_ID_MAPPING.editing,
  ],
  [PLAN_REF_ID_MAPPING_V1.max]: [PLAN_REF_ID_MAPPING.all],
};

export const oldPlanNewPlanNameMapping = {
  [PLAN_REF_ID_MAPPING_V1.select]: "Selects",
  [PLAN_REF_ID_MAPPING_V1.essential]: "Essentials",
  [PLAN_REF_ID_MAPPING_V1.pro]: "Pro",
  [PLAN_REF_ID_MAPPING_V1.pro_trial]: "Pro",
  [PLAN_REF_ID_MAPPING_V1.max]: "Max",
  [PLAN_REF_ID_MAPPING_V1.edit]: "Edit",
};
